import { cva } from '@/styled-system/css';

export const popoverContentRecipe = cva({
  base: {
    display: 'flex',
    borderRadius: 'obj.default',
    flexDirection: 'column',
    backgroundColor: 'bg.elevated.mediumShadow',
    filter: 'drop-shadow({shadows.Popover.Content})',
    maxWidth: '360px',
    maxHeight: '320px',
    position: 'relative',
  },
  variants: {
    modal: {
      true: {
        blockSize: 'auto',
        animation: 'zoom-in 0.2s ease-out',
      },
      false: {},
    },
  },
});

export const popoverContentPositionerRecipe = cva({
  variants: {
    modal: {
      true: {
        zIndex: 2,
      },
      false: {
        zIndex: 'popover',
      },
    },
    dividers: {
      true: {},
      false: {},
    },
    tone: {
      neutral: {},
      critical: {},
      info: {},
      success: {},
      warning: {},
    },
  },
  compoundVariants: [
    {
      dividers: true,
      tone: 'critical',
      css: {
        '& .c11n_divider': {
          backgroundColor: 'Popover.Divider.bg.critical',
        },
      },
    },
    {
      dividers: true,
      tone: 'info',
      css: {
        '& .c11n_divider': {
          backgroundColor: 'Popover.Divider.bg.info',
        },
      },
    },
    {
      dividers: true,
      tone: 'success',
      css: {
        '& .c11n_divider': {
          backgroundColor: 'Popover.Divider.bg.success',
        },
      },
    },
    {
      dividers: true,
      tone: 'warning',
      css: {
        '& .c11n_divider': {
          backgroundColor: 'Popover.Divider.bg.warning',
        },
      },
    },
  ],
});
